import { EMPTY_STR } from './constants/common';
import { ERROR } from './constants/tracking';

/**
 * Handles pushing an error message to the datalayer
 */

export default function handleDataLayerError(key: string | null = EMPTY_STR) {
    if (typeof window !== 'undefined' && window) {
        const adobeDataLayer = window && window.adobeDataLayer;
        if (adobeDataLayer) {
            adobeDataLayer.push({
                event: `${ERROR}:${key}`,
            });
        }
    }
}
